import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Collections, Infraction, Protest, useCollection } from "api";
import { useFormikContext } from "formik";
import React, { FC } from "react";
import { useFieldValueAndValidation } from "ui/componentes";

const fieldName = "infractionId";

interface ProtestInfractionSelectionProps {
    seasonId: string;
}

const ProtestInfractionSelection: FC<ProtestInfractionSelectionProps> = ({
    seasonId,
}) => {
    const { setFieldValue, setFieldTouched } = useFormikContext<Protest>();

    const infractions =
        useCollection<Infraction[]>(
            {
                collection: Collections.INFRACTIONS,
                where: ["seasonId", "==", seasonId],
                orderBy: ["key", "asc"],
                storeAs: `infractions_${seasonId}`,
            },
            true
        ) || [];

    infractions.sort((i1, i2) => (i1.key < i2.key ? -1 : 1));

    const { error, hasTouched } = useFieldValueAndValidation(fieldName);
    const showError = !!error && hasTouched;

    return (
        <Autocomplete
            style={{
                width: "100%",
            }}
            clearText="Limpar"
            options={infractions}
            onBlur={() => setFieldTouched(fieldName, true)}
            getOptionSelected={(option, infraction) =>
                option.id === infraction.id
            }
            onChange={(event, infraction) => {
                setFieldValue(fieldName, infraction ? infraction.id : "");
            }}
            getOptionLabel={(infraction) =>
                `${infraction.key} - ${infraction.description}`
            }
            renderInput={(params) => {
                return (
                    <TextField
                        required
                        {...params}
                        label="Baseado na infração"
                        error={showError}
                        helperText={showError ? error : ""}
                    />
                );
            }}
        />
    );
};

export { ProtestInfractionSelection };
